import { useEffect } from 'react';

import config from '@/config';

const origin = new URL(config.embeds.pricing).origin;

export interface IframeMessagePayload {
    eventType: string;
    payload?: Record<string, unknown>;
}

export const useReceiveIframeMessages = (callback: (eventData: IframeMessagePayload) => void) => {
    useEffect(() => {
        function onReceivedMessage(event: MessageEvent) {
            if (event.origin !== origin && !event.origin.startsWith('http://localhost')) {
                return;
            }

            const eventData = event.data as IframeMessagePayload;

            callback(eventData);
        }

        window.addEventListener('message', onReceivedMessage);

        return () => {
            window.removeEventListener('message', onReceivedMessage);
        };
    }, [callback]);
};
